import { Link } from "react-router-dom";
import { BadgePercent } from "lucide-react";
import { useAuth } from "../auth/AuthContext";

export default function CustomerDiscountAlert() {
  const { user } = useAuth();
  const percent = Number(user?.customerDiscount?.percent || 0);

  if (!user || user.role !== "user" || percent <= 0) return null;

  return (
    <div className="customer-discount-alert" role="status" aria-live="polite">
      <div className="customer-discount-alert__inner">
        <span className="customer-discount-alert__icon">
          <BadgePercent size={18} />
        </span>
        <div className="customer-discount-alert__copy">
          <strong>{percent}% customer discount active</strong>
          <span>Your saved account discount will apply automatically at checkout.</span>
        </div>
        <Link className="customer-discount-alert__link" to="/all-products">
          Shop with discount
        </Link>
      </div>
    </div>
  );
}
